import { Action } from '@ngrx/store';
import { IHauler } from '@cemex-core/cmx-api';
import { Vehicle } from '@cemex-core/cmx-api/models/vehicles/model/vehicle';

export enum OneClickVehiclesActionTypes {
  LOAD_VEHICLES = '[One Click] Load vehicles',
  LOAD_VEHICLES_COMPLETE = '[One Click] Load vehicles completed',
  SELECT_VEHICLE = '[One Click] Select vehicle',
  RESET = '[One Click] Vehicles reset',
}

export class OneClickLoadVehiclesAction implements Action {
  readonly type = OneClickVehiclesActionTypes.LOAD_VEHICLES;

  constructor(public payload: IHauler) {}
}

export class OneClickLoadVehiclesCompleteAction implements Action {
  readonly type = OneClickVehiclesActionTypes.LOAD_VEHICLES_COMPLETE;

  constructor(public payload: Vehicle[]) {}
}

export class OneClickSelectVehicleAction implements Action {
  readonly type = OneClickVehiclesActionTypes.SELECT_VEHICLE;

  constructor(public payload: Vehicle) {}
}

export class OneClickResetVehiclesAction implements Action {
  readonly type = OneClickVehiclesActionTypes.RESET;

  constructor() {}
}

export type OneClickVehiclesActions =
  | OneClickLoadVehiclesAction
  | OneClickLoadVehiclesCompleteAction
  | OneClickSelectVehicleAction
  | OneClickResetVehiclesAction;
